/**
 * An ambassador's share link: the canonical listing URL with `?ref=<handle>`.
 * Shared by the web dashboard and the app, so both copy the same link.
 * Any query already on the path is kept and so is the hash; an old `ref` is
 * replaced where it stood, and any duplicate `ref` is dropped.
 *
 * Built with strings, not `new URL`: the URL polyfill the app runs on Hermes
 * duplicates search params, which would ship links with two refs.
 */
export function buildRefLink(origin: string, path: string, handle: string): string {
  const hashAt = path.indexOf("#");
  const hash = hashAt >= 0 ? path.slice(hashAt) : "";
  const beforeHash = hashAt >= 0 ? path.slice(0, hashAt) : path;
  const queryAt = beforeHash.indexOf("?");
  const pathname = queryAt >= 0 ? beforeHash.slice(0, queryAt) : beforeHash;
  const query = queryAt >= 0 ? beforeHash.slice(queryAt + 1) : "";
  const ref = `ref=${encodeURIComponent(handle)}`;

  const params: string[] = [];
  let placed = false;
  for (const part of query.split("&")) {
    if (!part) continue;
    if (part === "ref" || part.startsWith("ref=")) {
      if (!placed) params.push(ref);
      placed = true;
      continue;
    }
    params.push(part);
  }
  if (!placed) params.push(ref);

  const base = origin.replace(/\/+$/, "");
  const slashPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${base}${slashPath}?${params.join("&")}${hash}`;
}

/** The public page address: `/<lang>/a/<handle>`. */
export function ambassadorPagePath(lang: string, handle: string): string {
  return `/${lang}/a/${handle}`;
}
